import React from "react";
import loadable from "@loadable/component";
import CalendarIcon from "../../Icons/CalendarIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";
import WelcomeIcon from "../../Icons/WelcomeIcon";

const BranchComponent = loadable(
  () => import("../../components/Branch/Branch"),
);
const Branch = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <WelcomeIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Branch</span>
      </div>
      <BranchComponent />
    </>
  );
};

export default Branch;
